module.exports = "<svg class=\"svg-icons-wrp__empty svg-icons svg-icons_text\"><use xlink:href=\"#icon-num\" /> </svg>\n";